import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="evenodd"><path fill="#fff" d="M5.728 8L5 8.691 10.008 14 15 8.69l-.729-.689-4.264 4.536z" /><circle fillOpacity=".2" cx="10" cy="10" r="9.5" /></g></svg>);